import axios from "axios";
import { baseUrl } from "../modules/account/login";
import { useContext } from "react";
import { AuthContext } from "../context/authContext";
import { useNavigate } from "react-router";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export function useCallDetails({
  id,
  location,
}: {
  id: string;
  location: "calls" | "leads";
}) {
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token!);
  const navigate = useNavigate();

  const getCallDetails = () => {
    const url = location === "calls" ? `calls/${id}` : `calls/${id}`;
    return axios
      .get(`${baseUrl}/${url}`, {
        headers: { Authorization: AuthStr },
      })
      .then((response) => {
        const data = response.data;
        return data;
      })
      .catch((e) => {
        if (e?.response?.data?.message === "Session expired")
          navigate("/account/logout");
        return Promise.reject(
          new Error(e?.message ?? "Check your internet connection")
        );
      });
  };
  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ["call_details", id, token],
    queryFn: () => getCallDetails(),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });

  return { isLoading, error, data: data?.data, refetch };
}

export function useCallProviderDetails({ id }: { id: string }) {
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token!);
  const navigate = useNavigate();

  const getCallDetails = () => {
    return axios
      .get(`${baseUrl}/calls/get_provider_calls/${id}`, {
        headers: { Authorization: AuthStr },
      })
      .then((response) => {
        const data = response.data;
        return data;
      })
      .catch((e) => {
        if (e?.response?.data?.message === "Session expired")
          navigate("/account/logout");
        return Promise.reject(
          new Error(e?.message ?? "Check your internet connection")
        );
      });
  };
  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ["provider_details", id, token],
    queryFn: () => getCallDetails(),
    placeholderData: keepPreviousData,
    enabled: !!id,
    refetchOnWindowFocus: false,
  });

  return { isLoading, error, data: data?.data, refetch };
}

export function useOnlyProviderDetails({ id }: { id: string }) {
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token!);
  const navigate = useNavigate();

  const getCallDetails = () => {
    return axios
      .get(`${baseUrl}/calls/get_provider_calls/${id}`, {
        headers: { Authorization: AuthStr },
      })
      .then((response) => {
        const data = response.data;
        return data;
      })
      .catch((e) => {
        if (e?.response?.data?.message === "Session expired")
          navigate("/account/logout");
        return Promise.reject(
          new Error(e?.message ?? "Check your internet connection")
        );
      });
  };
  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ["provider_details", id, token],
    queryFn: () => getCallDetails(),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });

  return { isLoading, error, data: data?.data, refetch };
}
